import { dismissAlertToasts } from '../hooks/useToaster/dismissAllToasts.ts';
import {
  setMobileReferenceMenuOpen,
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../redux/features/referenceBarUISlice.ts';
import { store } from '../redux/store.ts';

export const openCraftsmanAlerts = () => {
  dismissAlertToasts();
  store.dispatch(setSelectedDataSheet('craftsman-alerts'));
  store.dispatch(setReferenceViewOpen(true));
  store.dispatch(setMobileReferenceMenuOpen(false));
};
